import compact from "lodash/compact";
import { CvExportsButton } from "PFApp/components/cv_exports_button";
import { useSearchStoreContext } from "PFApp/search/search_context";
import { useTranslation } from "react-i18next";

import { HeaderToolbox } from "../../components/header_toolbox";
import css from "../search_page.module.scss";
import { matchesTab, profilesTab } from "../tabs_constants";

export const SearchPageExportButtons = () => {
  const { t } = useTranslation();
  const {
    search: { tab, matches, profiles, searchActivity }
  } = useSearchStoreContext();

  const exportButtonProps = {
    text: t("exportText"),
    icon: undefined,
    kind: "primary"
  } as const;

  return (
    <HeaderToolbox
      className={css.headerToolbox}
      items={compact([
        tab === matchesTab && (
          <CvExportsButton
            profileIds={(matches || []).map(({ profile }) => profile.id)}
            activityId={searchActivity?.id}
            {...exportButtonProps}
          />
        ),
        tab === profilesTab && (
          <CvExportsButton profileIds={(profiles || []).map(({ id }) => id)} {...exportButtonProps} />
        )
      ])}
    />
  );
};
